// Format a numeric model value for display. `undefined`/`NaN` render as an empty
// field so the control can legitimately be blank.
export const toText = (value: number | undefined): string =>
    value === undefined || Number.isNaN(value) ? '' : String(value)

// Parse displayed text back to the model. Blank, non-numeric and non-finite text
// collapses to `undefined` — the field never emits `NaN` or `Infinity`, so the
// value contract stays a clean, finite `number | undefined`. Whitespace-only text
// and `'Infinity'` need the explicit guards: `Number(' ')` is `0` and
// `Number('Infinity')` passes a bare `z.number()` but serialises to `null`.
export const toNumber = (text: string): number | undefined => {
    const trimmed = text.trim()
    if (trimmed === '') {
        return undefined
    }
    const parsed = Number(trimmed)
    return Number.isFinite(parsed) ? parsed : undefined
}
